import CustomModal from "../../../components/CustomModal";
import React, {useState} from "react";
import PlatformToggle from "../../../components/PlatformToggle";
import {FocusedItemsContentDesign} from "../../dynamicUi/elements/focused";
import {Carousel} from "react-responsive-carousel";
import {FOCUS_DISPLAY_TYPE} from "../enums";
import {MemoizedFocusedItemsProductView} from "../../dynamicUi/elements/focused/FocusedItemsProductView";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

const FocusItemsPreviewModal = ({showModal, setShowModal, loading, onUpdateFocusItem}) => {

  const [mobileView, setMobileView] = useState(true);



  return (
    <CustomModal
      title={showModal?.title}
      bodyClasses={mobileView ? 'max-w-md' : 'max-w-6xl'}
      isPreviewModal={true}
      preFooterComponent={
        <PlatformToggle mobileView={mobileView} mobileOnClick={() => setMobileView(true)}
                        webOnClick={() => setMobileView(false)}/>}
      showModal={showModal}
      setShowModal={() => setShowModal(false)}
      loading={loading}
    >
      <DndProvider backend={HTML5Backend} >
        <FocusItemDataPreviewView data={showModal} mobile={mobileView} onUpdateFocusItem={onUpdateFocusItem}/>
      </DndProvider>
    </CustomModal>
  );
};

export default FocusItemsPreviewModal;

export const FocusItemInBannerView = ({data}) => {
  return (
    <Carousel
      showThumbs={false}
      autoPlay={true}
      infiniteLoop={true}
      showArrows={true}
      showStatus={false}
    >
      {data?.items?.map((i) => {
        return (
          <img key={i.id} src={i.image_url} alt="images" className="h-full"/>
        );
      })}
    </Carousel>
  );
};

export const FocusItemDataPreviewView = ({data = {}, mobile=true, fromBlog = false, onUpdateFocusItem}) => {
  const isProductViewDisplayType = data?.display_type?.toUpperCase() === FOCUS_DISPLAY_TYPE[2].value;
  const isCustomType = data?.display_type?.toUpperCase() === FOCUS_DISPLAY_TYPE[3].value;
  const isGridDisplayType = data?.display_type?.toUpperCase() === FOCUS_DISPLAY_TYPE[0].value;
  const isListDisplayType = data?.display_type?.toUpperCase() === FOCUS_DISPLAY_TYPE[1].value;
  return (
    <>
      {isGridDisplayType || isListDisplayType || isCustomType ? (
        <FocusedItemsContentDesign section={{...data}} focused={{init: true, data: data}} sideClass=""
                                      mobile={mobile} showTitle={true} onUpdateFocusItem={onUpdateFocusItem}
          allowDrag={true}/>
      ) : isProductViewDisplayType ?
        <MemoizedFocusedItemsProductView mobile={mobile} noRedux={fromBlog}
                                               focused={{init: true, data: data}}
                                               type={data?.type}/>:
        <FocusItemInBannerView data={data} />
      }
    </>
  );
};

